/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `noDevice` - Brak urządzenia
 * * `permissionDenied` - Brak zgody na powiadomienia
 * * `transport` - Błąd transportu
 * * `rejected` - Odrzucone przez FCM
 */
export type NotificationFailureReasonEnum = typeof NotificationFailureReasonEnum[keyof typeof NotificationFailureReasonEnum];


export const NotificationFailureReasonEnum = {
  noDevice: 'noDevice',
  permissionDenied: 'permissionDenied',
  transport: 'transport',
  rejected: 'rejected',
} as const;
